import React, { useEffect, useState } from 'react';
import { get } from '../../utils/api';

function WeeklySnapshots({ childId }) {
  const [snapshots, setSnapshots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingUrlId, setLoadingUrlId] = useState(null);

  useEffect(() => {
    if (!childId) return;
    setLoading(true);
    get(`/weekly-snapshots/child/${childId}`, true)
      .then((data) => setSnapshots(data || []))
      .catch(() => setSnapshots([]))
      .finally(() => setLoading(false));
  }, [childId]);

  const handleViewSnapshot = async (snapshotId) => {
    setLoadingUrlId(snapshotId);
    try {
      const { url } = await get(`/weekly-snapshots/${snapshotId}/pdf-url`, true);
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch {
      alert('Could not load snapshot. Please try again.');
    } finally {
      setLoadingUrlId(null);
    }
  };

  const completedSnapshots = snapshots.filter((s) => s.status === 'complete' && s.pdfS3Key);

  if (loading) {
    return (
      <div className="py-10 flex items-center gap-2 text-gray-600">
        <span className="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-gray-600" />
        <span>Loading snapshots...</span>
      </div>
    );
  }

  if (completedSnapshots.length === 0) {
    return (
      <div className="p-3 rounded-lg border bg-gray-50 text-gray-700 text-sm">
        No weekly snapshots available yet.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {completedSnapshots.map((snapshot) => {
        const weekLabel = new Date(snapshot.reportWeekStart).toLocaleDateString('en-GB', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        });
        return (
          <div
            key={snapshot._id}
            className="flex items-center justify-between rounded-lg border border-gray-200 p-4"
          >
            <div>
              <span className="font-medium text-gray-800">Week of {weekLabel}</span>
            </div>
            <button
              onClick={() => handleViewSnapshot(snapshot._id)}
              disabled={loadingUrlId === snapshot._id}
              className="rounded-md bg-indigo-600 px-3 py-1.5 text-sm text-white hover:bg-indigo-700 disabled:opacity-50"
            >
              {loadingUrlId === snapshot._id ? 'Loading...' : 'View Snapshot'}
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default WeeklySnapshots;
